<template>
  <div>
    <div class="position-relative pb-5">
      <div class="w100">
        <div class="row mb-1 pb-1 border-bottom">
          <div class="col-2">
            <p class="fs-6 mb-0 pb-0">申請データ</p>
          </div>
        </div>
        <div class="container">
          <div class="row mb-3">
            <div class="col-2">
              <p class="text-center py-1 fs-7">申請状況</p>
            </div>
            <div class="col-3">
              <bs-select
                :options="application_check_type_list"
                :nullOption="false"
                v-model="application_obj.application_check_type"
                disabled
              ></bs-select>
            </div>
            <div class="col-2">
              <p class="fs-6 mb-0 pb-0">申請区分</p>
            </div>
            <div class="col-3">
              <bs-select
                :options="application_type_list"
                :nullOption="false"
                v-model="application_obj.application_type"
                disabled
              ></bs-select>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">申請日</p>
          </div>
          <div class="col-4">
            <input
              type="text"
              class="form-control"
              v-model="application_obj.application_date_label_YmdHi"
              disabled
            />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">全体コメント</p>
          </div>
          <div class="col-10">
            <textarea
              class="form-control"
              rows="3"
              v-model="application_obj.comment"
              :disabled="application_obj.application_check_type == 500"
              placeholder="申請全体に対するコメントを入力してください"
            ></textarea>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">承認/差し戻し</p>
          </div>
          <div class="col-3">
            <div class="input-group">
              <span
                class="input-group-text"
                v-if="application_obj.permission_date"
                >承認済</span
              >
              <span
                class="input-group-text"
                v-if="application_obj.permission_manage_label"
                >{{ application_obj.permission_manage_label }}</span
              >
              <template v-else-if="chk_relation_type_editable('/club/data')">
                <button
                  @click="setPermission"
                  type="button"
                  class="btn btn-primary me-2"
                  :disabled="application_obj.application_check_type == 500"
                >
                  承認する
                </button>
                <button
                  @click="showRejectModal"
                  type="button"
                  class="btn btn-warning"
                  :disabled="application_obj.application_check_type == 500"
                >
                  差し戻す
                </button>
              </template>
            </div>
          </div>
          <div
            class="col-2"
            v-if="
              application_obj?.application_type == 21000 &&
              application_obj?.application_check_type != 500
            "
          >
            <p class="text-center py-1 fs-7">登録時クラブコード</p>
          </div>
          <div
            class="col-4"
            v-if="
              application_obj?.application_type == 21000 &&
              application_obj?.application_check_type != 500
            "
          >
            <input type="text" class="form-control" v-model="set_club_no" />
          </div>
        </div>

        <div class="row mb-1 pb-1 border-bottom">
          <div class="col-2">
            <p class="fs-6 mb-0 pb-0">申請内容</p>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 15%">申請</th>
                  <th style="width: 30%">内容</th>
                  <th style="width: auto" v-show="false">コメント</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in application_obj.items" :key="item.id">
                  <td>{{ formatLabel(item.application_key) }}</td>
                  <td>
                    <div
                      v-if="
                        item.application_key.indexOf('event_relation') !== -1
                      "
                    >
                      <p
                        class="form-control-plaintext"
                        v-for="event in item.application_value"
                        :key="event"
                      >
                        {{ get_list_label(event, event_cd_obj) }}
                      </p>
                    </div>
                    <p class="form-control-plaintext" v-else>
                      {{ formatValue(item.application_value) }}
                    </p>
                  </td>
                  <td v-show="false">
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.message"
                      :disabled="application_obj.application_check_type == 500"
                      placeholder="コメントを入力"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 差し戻しモーダル -->
    <div class="modal fade" id="rejectModal" tabindex="-1" ref="rejectModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">申請の差し戻し</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">差し戻しコメント（全体）</label>
              <textarea
                class="form-control"
                v-model="application_obj.comment"
                rows="3"
                placeholder="差し戻しの理由を入力してください"
              ></textarea>
              <small class="text-muted">
                ※個別の項目に対するコメントは、申請内容の各項目のコメント欄に入力してください。
              </small>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              キャンセル
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click="rejectApplication"
            >
              差し戻す
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.fs-6 {
  font-size: 1.15rem !important;
}
.fs-7 {
  font-size: 1rem !important;
}
.fs-8 {
  font-size: 0.9rem !important;
}
</style>
<script>
import { mapState } from 'vuex'
// import BsPageTitle from '../../molecules/BsPageTitle.vue'
// import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
import config from '../../../const'
import common from '../../../common/common'
import * as bootstrap from 'bootstrap'

export default {
  name: 'ClubApplication21000View',
  data: function () {
    return {
      targetid: this.get_targetid,
      fromParentTitle: 'クラブ申請詳細',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      application_obj: {},
      application_check_type_obj: [],
      application_type_obj: [],
      application_key_obj: [],
      event_cd_obj: [],
      search_license_no: '',
      search_member_name_label: '',
      item_column: {
        id: 0,
        application_id: 0,
        application_key: '',
        application_value: '',
        permission_date: '',
        permission_sw: false,
        permission_manage_id: '',
        permission_manage_label: '',
        message: ''
      },
      oParam: ['item'],
      rejectModal: null,
      set_club_no: '',
      set_application_check_type: ''
    }
  },
  components: {
    // BsPageTitle,
    BsSelect
    // BsMsgAlert
  },
  methods: {
    async add_item() {
      const tmps = { ...this.item_column }
      tmps.manage_id = this.$store.state.auth.userId
      tmps.manage_label = this.$store.state.auth.label
      const items =
        typeof this.application_obj.items === 'object'
          ? this.application_obj.items
          : []
      items.push(tmps)
      this.application_obj.items = items
    },
    async set_application_permission() {
      this.application_obj.permission_manage_id = this.$store.state.auth.userId
      this.application_obj.permission_date_date = common.getToday()
      this.application_obj.permission_manage_label =
        this.$store.state.auth.label
    },
    async clear_application_permission() {
      this.application_obj.permission_manage_id = 0
      this.application_obj.permission_date_date = ''
      this.application_obj.permission_manage_label = ''
    },
    async set_item_permission(index) {
      this.application_obj.items[index].permission_manage_id =
        this.$store.state.auth.userId
      this.application_obj.items[index].permission_date_date = common.getToday()
      this.application_obj.items[index].permission_manage_label =
        this.$store.state.auth.label
    },
    async clear_item_permission(index) {
      this.application_obj.items[index].permission_manage_id = 0
      this.application_obj.items[index].permission_date_date = ''
      this.application_obj.items[index].permission_manage_label = ''
    },

    async loadConfigObj(param) {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/config/' + param, params)
        .then(async response => {
          console.log('loadConfigObj response', response)
          this[param + '_obj'] =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this[param + '_obj'] = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async search_member_license_no() {
      if (this.search_license_no.length == 6) {
        await this.loadMemberList(this.search_license_no)
      }
    },
    async loadMemberList(license_no) {
      const params = {}
      params['stat'] = [1]
      params['license_no'] = license_no
      params['pagegroup'] = 'mfj_club_data.id'

      await this.basicPosts_S(config.BASE_API_URL + '/club/lists', params)
        .then(async response => {
          console.log('loadMemberList response', response)
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
          let name_label = ''
          if (typeof tmp_obj.name_1 === 'string') name_label += tmp_obj.name_1
          if (typeof tmp_obj.name_2 === 'string') name_label += tmp_obj.name_2
          if (typeof tmp_obj.name_3 === 'string') name_label += tmp_obj.name_3
          this.search_member_name_label = name_label
          this.application_obj.m_id = tmp_obj.id
        })
        .catch(async err => {
          console.log(err)
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadMemberObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/club_application/lists',
        params
      )
        .then(async response => {
          console.log('loadMemberObj', response)
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}

          if (!tmp_obj.items) {
            tmp_obj.items = []
          }
          const items = tmp_obj.items.map(item => {
            if (this.is_json(item.application_value)) {
              item.application_value = JSON.parse(item.application_value)
            }
            return item
          })
          tmp_obj.items = items

          this.application_obj = tmp_obj
          console.log('Loaded application_obj:', this.application_obj)
        })
        .catch(async err => {
          console.log(err)
          this.application_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadEventCdObj() {
      try {
        const response = await this.basicPosts_S(
          `${config.BASE_API_URL}/event_cd/lists`,
          { stat: [1] }
        )
        if (response.data?.status === 200) {
          this.event_cd_obj = response.data.body || []
          console.log('Loaded events:', this.event_cd_obj)
        }
      } catch (error) {
        console.error('Error loading events:', error)
        this.event_cd_obj = []
      }
    },
    async update_application() {
      const params = this.application_obj
      if (this.pass_chg_sw && this.pass_chg_confirm != this.login_pass_input) {
        alert('パスワードが一致しません')
        return true
      } else if (this.pass_chg_sw && this.pass_chg_confirm == '') {
        alert('パスワードを入力して下さい')
        return true
      } else if (
        this.pass_chg_sw &&
        this.pass_chg_confirm == this.login_pass_input
      ) {
        params.login_pass = this.login_pass_input
      }

      await this.update(params)
    },
    async update(params) {
      console.log('component methods', this.application_obj)
      const post_url = this.not_add
        ? config.BASE_API_URL + '/club_application/edit/' + this.targetid
        : config.BASE_API_URL + '/club_application/add'

      let result = true
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          console.log('update member response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.alertMessage = this.btnLabel + 'しました'
            this.alertClass = 'alert-success'
            this.targetid = response.data.body[0].id
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
            if (typeof response.data.alert.error_obj === 'object') {
              const tmp_error = { ...this.member_error_obj }
              Object.keys(response.data.alert.error_obj).forEach(key => {
                tmp_error[key] = response.data.alert.error_obj[key]
              })
              this.member_error_obj = tmp_error
            }
          } else {
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) await this.loadMemberObj()
          this.$forceUpdate()
          alert(this.alertMessage)
        })
    },
    back() {
      this.$router.go(-1)
    },
    tab_switch_action(tab) {
      this.tab_active = tab
    },
    go_consulting() {
      this.$router.push({
        // name: 'process_detail',
        path: '/consulting/add',
        query: {
          m_id: this.targetid,
          clinic_id: this.application_obj.main_clinic_id
        }
      })
    },
    formatLabel(key) {
      const labelMap = {
        'mfj_club_data@login_id': 'ログインID',
        'mfj_club_data@login_pass': 'パスワード',
        'mfj_club_data@name_1': 'クラブ名',
        'mfj_club_data@name_2': '責任者姓',
        'mfj_club_data@name_3': '責任者名',
        'mfj_club_data@yomi_1': 'クラブ名カナ',
        'mfj_club_data@yomi_2': '責任者セイ',
        'mfj_club_data@yomi_3': '責任者メイ',
        'mfj_club_profile@postal_cd': '郵便番号',
        'mfj_club_profile@pref_cd': '都道府県',
        'mfj_club_profile@address_1': '住所1',
        'mfj_club_profile@address_2': '住所2',
        'mfj_club_profile@tel_1': '電話番号1',
        'mfj_club_profile@tel_2': '電話番号2',
        'mfj_club_profile@mail_1': 'メールアドレス',
        'mfj_club_profile@website_url_1': 'Webサイト',
        'mfj_owner_data@event_relation': '活動種目'
      }
      // const parts = key.split('@')
      // return labelMap[parts[1]] || parts[1] || key
      return labelMap[key]
    },
    formatValue(value) {
      if (!value) return ''

      try {
        const parsed = JSON.parse(value)
        if (Array.isArray(parsed)) {
          return parsed.join(', ')
        }
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        return value
      }
    },
    isJsonValue(value) {
      try {
        JSON.parse(value)
        return true
      } catch (e) {
        return false
      }
    },
    async setPermission() {
      if (confirm('この申請を承認しますか？')) {
        this.set_application_check_type = '500'
        await this.updateApplication()
      }
    },
    getToday() {
      const today = new Date()
      const yyyy = today.getFullYear()
      const mm = String(today.getMonth() + 1).padStart(2, '0')
      const dd = String(today.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    async updateApplication() {
      if (!this.set_club_no && this.set_application_check_type == 500) {
        alert('club noを入力して下さい。')
        this.set_application_check_type = ''
        return
      } else if (this.set_application_check_type == 500) {
        const chk = await this.basicPosts_S(
          config.BASE_API_URL + '/club/lists',
          {
            club_no: this.set_club_no
          }
        ).then(async response => {
          return response?.data &&
            response?.data?.body &&
            Array.isArray(response.data.body) &&
            response.data.body.length > 0
            ? true
            : false
        })
        if (chk) {
          alert('そのclub noは使えません')
          this.set_application_check_type = ''
          return
        }
      }
      const params = { ...this.application_obj }
      // club_no
      params.application_check_type = this.set_application_check_type
      if (this.set_application_check_type == 500) {
        params.set_club_no = this.set_club_no
        params.permission_date_date = this.getToday()
        params.permission_manage_id = this.$store.state.auth.userId
        params.permission_manage_label = this.$store.state.auth.label
      }

      // app_type:join(申請承認登録時JOINをセットしておく。)
      // club_idが
      if (this.set_application_check_type == 500) params.app_type = 'join'
      const url =
        this.set_application_check_type == 500
          ? config.BASE_API_URL + '/club_application/join_edit/' + this.targetid
          : this.set_application_check_type == 600
          ? config.BASE_API_URL +
            '/club_application/reject_edit/' +
            this.targetid
          : config.BASE_API_URL + '/club_application/edit/' + this.targetid
      this.set_application_check_type = ''
      try {
        const response = await this.basicPosts_I(url, params)
        console.log('updateApplication response', response)
        if (response.data && response.data.status == '200') {
          this.alertMessage = '更新が完了しました'
          this.alertClass = 'alert-success'
          await this.loadMemberObj()
        } else {
          this.alertMessage = '更新に失敗しました'
          this.alertClass = 'alert-danger'
        }
      } catch (error) {
        console.error('Error:', error)
        this.alertMessage = '更新に失敗しました'
        this.alertClass = 'alert-danger'
      }
      alert(this.alertMessage)
    },
    // async setItemPermission(index) {
    //   if (confirm('この項目を承認しますか？')) {
    //     const today = this.getToday()
    //     this.application_obj.items[index].permission_date = today
    //     this.application_obj.items[index].permission_date_date = today
    //     this.application_obj.items[index].permission_manage_id =
    //       this.$store.state.auth.userId
    //     this.application_obj.items[index].permission_manage_label =
    //       this.$store.state.auth.label
    //     await this.updateApplication()
    //   }
    // },
    showRejectModal() {
      this.rejectModal.show()
    },
    async rejectApplication() {
      if (!this.application_obj.comment) {
        alert('差し戻しコメントを入力してください')
        return
      }

      this.set_application_check_type = '600'
      await this.updateApplication()
      this.rejectModal.hide()
    }
  },
  computed: {
    ...mapState({
      // sex_type_list: state => state.apidata.sex_type,
    }),
    get_list_label: function () {
      return function (key, lists) {
        if (
          key &&
          typeof lists === 'object' &&
          lists.find(list => list.key == key)
        ) {
          return (lists.find(list => list.key == key) || {}).label
        }
        return key
      }
    },
    application_type_list: function () {
      return this.application_type_obj
    },
    application_check_type_list: function () {
      return this.application_check_type_obj
    },

    not_add: function () {
      return this.targetid != 'add' && !Number.isNaN(this.targetid)
        ? true
        : false
    }
  },

  async created() {
    await this.loadEventCdObj()
    await this.loadConfigObj('application_check_type')
    await this.loadConfigObj('application_type')
    await this.loadConfigObj('application_key')
    // await this.loadConfigObj('application_key.210');

    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      await this.loadMemberObj()
      this.btnLabel = '更新'
    } else {
      this.application_obj = Object.assign({
        id: 0,
        stat: 1,
        m_id: 0,
        application_check_type: '',
        application_type: '',
        application_date: '',
        permission_date_date: '',
        permission_date: '',
        permission_manage_id: '',
        permission_manage_label: '',
        permission_sw: false,
        items: []
      })
      this.btnLabel = '登録'

      // set
      // this.application_obj.profile.push({...this.profile_column});
      // this.application_obj.insurance.push({...this.insurance_column});
      this.oParam.forEach(param => {
        const param_key = param + '_column'
        if (this.application_obj[param] === false) {
          this.application_obj[param] = []
        }
        if (
          typeof this.application_obj[param] !== 'object' ||
          (typeof this.application_obj[param] === 'object' &&
            this.application_obj[param].length <= 0)
        ) {
          this.application_obj[param].push({ ...this[param_key] })
        }
      })
    }
    this.alertMessage = this.btnLabel + 'できます'

    this.$forceUpdate()
  },
  mounted() {
    // モーダルの初期化を修正
    const modalEl = this.$refs.rejectModal
    if (modalEl) {
      this.rejectModal = new bootstrap.Modal(modalEl)
    }
  },
  props: {
    get_targetid: {
      type: Number,
      default: () => 0
    }
  }
}
</script>
